import BasketApi from "../Api/basket-api";
import {modal} from "../UI/modal";


const updateItem = (item, count, coupon, paymentVariant, events) => {
    let id = item.dataset.basket_id;
    item.querySelector('.js_item_total_price').classList.add('preloader');
    item.querySelector('.js_count_component').disabled = true;
    item.querySelector('.format_decrement').disabled = true;
    item.querySelector('.format_increment').disabled = true;


    BasketApi.update(id, count[0].count || 0, coupon, paymentVariant)
        .then(e => e.json())
        .then(e => {
            events.dispatch('item.updated', e);
        })
        .catch(e => {
            events.dispatch('item.updated.error', e);
            modal({'message': 'Ошибка обновления <h3>Попробуйте ещё раз.</h3>'} );
        })
        .finally(() => {
            item.querySelector('.js_item_total_price').classList.remove('preloader');
            item.querySelector('.js_count_component').disabled = false;
            item.querySelector('.format_decrement').disabled = false;
            item.querySelector('.format_increment').disabled = false;
        });
};
export default updateItem;
